let lastId = 0
export function elementId(prefix: string = "el") {
    const id = Math.floor(Math.random() * (10000 * lastId - 1 * lastId) + lastId)
    lastId++
    return `${prefix}${id}`
}
